import React from 'react';
import styles from './style.js';
import { withStyles } from '@material-ui/core/styles';

import MUTypography from '../ui/MUTypography/index.js';

class BasicPageComponent extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <div className={`${classes.container} ${this.props.type === '2' && 'bg-white'}`}>
        <div className = {classes.intro} >
          <MUTypography paragraph={true} className={classes.title}>
            {this.props.title}
          </MUTypography>
          <MUTypography paragraph={true} className={classes.description}>
            {this.props.description}
          </MUTypography>
        </div>
        <div className={`${this.props.shape === 'wide' ? 'container' : classes.body }`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(BasicPageComponent);

